// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_icon__ezupZ {
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translate(0, -50%);
}`, "",{"version":3,"sources":["webpack://./src/components/ui/input/inputText/styles.module.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,6BAAA;AADF","sourcesContent":["@import './src/assets/styles/variables/colors';\n\n.icon {\n  position: absolute;\n  top: 50%;\n  right: 16px;\n  transform: translate(0, -50%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon": `styles_icon__ezupZ`
};
export default ___CSS_LOADER_EXPORT___;
